import angular from 'angular';

import BaseMap from './map';
import AccountModel from './account';

function AccountMapFactory(Account, BaseMap) {
	return class AccountMap extends BaseMap {
		constructor() {
			super(Account);
		}
	}
}
AccountMapFactory.$inject = ['Account', 'BaseMap'];

export default angular.module('maps.account', [AccountModel, BaseMap])
	.factory('AccountMapFactory', AccountMapFactory)
	.service('AccountMap', ['AccountMapFactory', AccountMapFactory => new AccountMapFactory()])
	.name;



// WEBPACK FOOTER //
// ./project/models/account-map.js